import axios from 'axios';

import { GetAxiosAuthConfig } from '../mixins/axiosAuth'
import { eventBusPublished } from '../main';

export const GetReviewables = {
    mixins: [GetAxiosAuthConfig],
    data() {
        return {
            reviewables : [],
        }
    },
    watch: {
    },
    computed: {
        NonePublished() {
            // create a warning that published filter returned no results
            if (eventBusPublished.only_published == true && this.reviewables.length == 0) {
                return true
            }
            else {
                return false
            }
        },
        NoResults() {
            if (this.reviewables.length == 0) {
                return true
            }
            else {
                return false
            }
        }
    },
    methods: {
        GetReviewables() {
            // using the global variables create the rest url to get
            let limit = 27
            
            // start url with project
            let resturl = window.location.origin + '/api/reviewables/'

            // instead of a filter, this is a different REST URL
            if (this.query_shared != undefined) {
                resturl += 'shared/'
            }

            // build more
            resturl += '?format=json&limit=' + limit

            // Project will be undefined if not in the router URL (this.$route.params.project)
            if (this.project != undefined) {
                resturl +=  '&project=' + this.project
            }

            // Shot will be undefined if not in the router URL (this.$route.params.shot)
            if (this.shot != undefined) {
                resturl += '&shot=' + this.shot
            }

            // check for queries set in src\mixins\querys.js
            if (this.query_user != undefined) {
                resturl += '&user=' + this.query_user
            }

            if (this.query_tags != undefined) {
                resturl += '&tags__name=' + this.query_tags
            }
            
            // search is a query too
            if (this.query_search != undefined) {
                resturl += '&search=' + this.query_search
            }

            // get published from eventbus not queries
            if (eventBusPublished.only_published == true) {
                resturl += '&published=true' 
            }

            if (process.env.NODE_ENV == 'development') {
                console.info('mixin/reviewables.js - resturl', resturl)
            }

            axios.get(resturl, axios_auth_config)
                .then(response => {
                    this.reviewables_response = response
                    this.reviewables = response.data.results

                    // also save the url for the next page to allow infinate scrolling
                    this.page_next_url = response.data.next
                })
                .catch(error => console.error("get next page url error", error))
        },
    },
    mounted() {
        this.GetReviewables()
        
        // watch for publish_toggled emitted from eventBusPublished
        eventBusPublished.$on('publish_toggled', (only_published) => {
            this.GetReviewables()
        })
    },
}
